var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wo-page" },
    [
      _c(
        "div",
        { staticClass: "hero" },
        [
          _vm._m(0),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.openCreate },
            },
            [_vm._v("新开工单")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "编号 / 标题 / 联系人",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部类型" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.workOrderType,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "workOrderType", $$v)
                        },
                        expression: "searchForm.workOrderType",
                      },
                    },
                    _vm._l(_vm.types, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部状态" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    _vm._l(_vm.statuses, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "metrics" }, [
        _c("div", [
          _c("span", [_vm._v("工单总数")]),
          _c("strong", [_vm._v(_vm._s(_vm.tableData.total || 0))]),
        ]),
        _c("div", { staticClass: "warning" }, [
          _c("span", [_vm._v("当前页待派")]),
          _c("strong", [_vm._v(_vm._s(_vm.count("pending_dispatch")))]),
        ]),
        _c("div", [
          _c("span", [_vm._v("当前页执行中")]),
          _c("strong", [_vm._v(_vm._s(_vm.count("executing")))]),
        ]),
        _c("div", { staticClass: "success" }, [
          _c("span", [_vm._v("当前页待验收")]),
          _c("strong", [_vm._v(_vm._s(_vm.count("pending_acceptance")))]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "title-row" },
            [
              _c("div", [
                _c("strong", [_vm._v("服务工单台账")]),
                _c("span", [
                  _vm._v("派工、预约和验收都会回写工单真值，待办中心只是投影"),
                ]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "workOrder.workOrderNo",
                  label: "工单编号",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(_vm.typeText(row.workOrder.workOrderType))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "workOrder.title",
                  label: "标题",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "projectName",
                  label: "工地",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "workOrder.contactName",
                  label: "联系人",
                  width: "110",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "providerName", label: "服务人", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTag[row.workOrder.status],
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.workOrder.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "260",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(row.actions, function (action) {
                        return _c(
                          "el-button",
                          {
                            key: action,
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.runAction(row, action)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.actionText(action, row.workOrder.status)
                              )
                            ),
                          ]
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新开服务工单",
            visible: _vm.createVisible,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "88px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工地" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "选择工地" },
                      model: {
                        value: _vm.createForm.projectId,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "projectId", $$v)
                        },
                        expression: "createForm.projectId",
                      },
                    },
                    _vm._l(_vm.projects, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.projectName || item.name,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.createForm.workOrderType,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "workOrderType", $$v)
                        },
                        expression: "createForm.workOrderType",
                      },
                    },
                    _vm._l(_vm.types, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标题" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "200" },
                    model: {
                      value: _vm.createForm.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.createForm,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "createForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "说明" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3, maxlength: "2000" },
                    model: {
                      value: _vm.createForm.content,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.createForm,
                          "content",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "createForm.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "地址" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "500" },
                    model: {
                      value: _vm.createForm.serviceAddress,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.createForm,
                          "serviceAddress",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "createForm.serviceAddress",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系人" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.createForm.contactName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.createForm,
                          "contactName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "createForm.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "电话" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "18" },
                    model: {
                      value: _vm.createForm.contactMobile,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.createForm,
                          "contactMobile",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "createForm.contactMobile",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.createVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.createOrder },
                },
                [_vm._v("开单")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("SERVICE DISPATCH & CLOSE LOOP")]),
      _c("h2", [_vm._v("服务工单")]),
      _c("p", [
        _vm._v(
          "量房、送货、安装、维修、售后和监控统一派工：待派 → 待确认 → 待预约 → 执行中 → 待验收 → 完成。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }